import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { FormsModule } from "@angular/forms";
import { AppCommonsModule } from "src/app/commons/app-commons.module";
import { PlessSharedModule } from "src/app/shared/pless-shared.module";
import { KYMW6901MasterInputTabComponent } from "./kymw6901-master-input-tab.component";
import { GetMasterInputService } from "./api-services/get-master-input.service";
import { GetNewGoodsProposalService } from "./api-services/get-new-goods-proposal.service";
import { UpdateMasterInputService } from "./api-services/update-master-input.service";
import { RegistMasterInputService } from "./api-services/regist-master-input.service";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WjInputModule,
    WjNavModule,
    AppCommonsModule,
    PlessSharedModule
  ],
  declarations: [KYMW6901MasterInputTabComponent],
  providers: [
    GetMasterInputService,
    GetNewGoodsProposalService,
    UpdateMasterInputService,
    RegistMasterInputService
  ],
  exports: [
    KYMW6901MasterInputTabComponent,
  ]
})
export class KYMW6901MasterInputTabModule { }